// removed by extract-text-webpack-plugin
module.exports = {"widget":"widget--1GOng","glossaryLink":"glossaryLink--9FZkM"};